import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-info-card-footer',
  templateUrl: './info-card-footer.component.html',
  styleUrls: ['./info-card-footer.component.scss'],
})
export class InfoCardFooterComponent {}
